<template>
  <GlobalWrapper
    :style="{ backgroundImage: 'url(' + campaign?.background + ')' }"
    class="py-20 bg-cover min-h-screen"
  >
    <Modal
      :modalOpen="true"
      headerText="Verify Your Donation"
      :subheaderText="`By clicking the button below, I confirm that:`"
      :ctaText="`Confirm ${frequency} Donation`"
      :showCancelButton="false"
      :successState="success"
      :hideCtaOnSuccess="true"
      @closeModal="verifyDonation"
      @cancelAction="goBack"
    >
      <div class="mt-4 text-left space-y-2 text-sm text-gray-700">
        <ul class="list-disc pl-5">
          <li>I am at least 25 years old</li>
          <li>
            The frequency of my donation is: <strong>{{ frequency }}</strong>
          </li>
          <li>
            For the amount of: <strong>${{ amount }}</strong>
          </li>
          <li>
            The fundraiser I spoke with is: <strong>{{ fundraiserName }}</strong>
          </li>
          <li>
            My email address is: <strong>{{ email }}</strong>
          </li>
        </ul>

        <p v-if="success" class="text-green-600">Donation verified successfully!</p>
        <p v-if="success" class="text-green-600">You may close out of this tab at any time.</p>
        <p v-if="error" class="text-red-600">Verification failed. Please try again.</p>
      </div>
    </Modal>
  </GlobalWrapper>
</template>

<script>
import { onBeforeMount, ref, computed } from 'vue'
import GlobalWrapper from '../components/GlobalWrapper'
import { useRoute, useRouter } from 'vue-router'
import Modal from '@/components/Modal.vue'
import { DonationApi } from '../services/donations/api'
import { CampaignApi } from '../services/campaign/api'
import { donorLinkCredential } from '../services/formAccess'

export default {
  name: 'DonationVerification',
  components: {
    Modal,
    GlobalWrapper,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const uniqueId = route.params.uniqueId
    const campaignId = route.query.campaign
    const amount = route.query.d_amount
    const frequency = route.query.d_frequency
    const email = route.query.d_email
    // Django adds both when it sends the text: the grant that lets this page act without
    // a login, and the name of the fundraiser that grant identifies.
    const { formToken, legacyFundraiser } = donorLinkCredential(route)
    const fundraiserName = computed(() => route.query.d_fundraiser || '')

    const campaign = ref()
    const success = ref(false)
    const error = ref(false)

    onBeforeMount(async () => {
      try {
        campaign.value = await CampaignApi.csc.customRetrieve({
          campaign: campaignId,
          formToken,
          legacyFundraiser,
        })
      } catch (e) {
        console.error(e)
      }
    })

    const verifyDonation = async () => {
      try {
        success.value = false
        error.value = false
        await DonationApi.csc.updateDonationVerificationStatus({
          uniqueId: uniqueId,
          verified: true,
          formToken,
          legacyFundraiser,
        })
        success.value = true
      } catch (err) {
        error.value = true
        console.error(err)
      }
    }

    const goBack = () => {
      router.push('/')
    }

    return {
      frequency,
      amount,
      success,
      error,
      verifyDonation,
      goBack,
      campaign,
      fundraiserName,
      email,
    }
  },
}
</script>
